import SingleSelect from './singleSelect.vue';
import Place from './place.vue';
import ResultsButton from './resultsButton.vue';

export default {
    name: 'RealtySearchBar',
    template: '#realty-search-bar',
    components: { SingleSelect, Place, ResultsButton },
    props: {
        initialResults: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    computed: {
        loading() {
            return this.requestsCt && this.requests.size !== 0; // reactivity-hack
        },
    },
    data() {
        return {
            kind: '',
            category: '',
            place: '',

            kindValues: [],
            categoryValues: [],

            results: 0,

            requestsCt: 0,
            requests: new Set(),
            previousRequest: null,
        };
    },
    created() {
        this.results = this.initialResults;
    },
    mounted() {
        const searchFields = CONFIG.misc.searchFields,
            kindValues = [],
            categoryValues = [];

        if (!searchFields) {
            return;
        }

        for (let key in searchFields.objektart) {
            if (Object.prototype.hasOwnProperty.call(searchFields.objektart, key)) {
                kindValues.push(searchFields.objektart[key]);
            }
        }

        for (let key in searchFields.vermarktungsart) {
            if (Object.prototype.hasOwnProperty.call(searchFields.vermarktungsart, key)) {
                categoryValues.push(searchFields.vermarktungsart[key]);
            }
        }

        this.kindValues = kindValues;
        this.categoryValues = categoryValues;
    },
    methods: {
        async fetchResults() {
            let request;

            if (this.previousRequest) {
                this.previousRequest.abort();
            }

            try {
                const json = {
                    kind: this.kind,
                    category: this.category,
                    pids: this.place,
                };

                this.previousRequest = new AbortController();

                request = fetch(CONFIG.misc.searchEndpoint, {
                    signal: this.previousRequest.signal,
                    method: 'POST',
                    body: JSON.stringify(json),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                this.requestsCt += 1;
                this.requests.add(request);

                let response = await request;

                if (response) {
                    let { count } = await response.json();

                    if (count !== false) {
                        this.results = count;
                    }
                }
            } catch (e) {
                //
            }

            this.requestsCt -= 1;
            this.requests.delete(request);

            this.previousRequest = null;
        },
        onSubmit() {
            const url = new URL(this.$el.action);

            if (this.kind) {
                url.searchParams.set('kind', this.kind);
            }

            if (this.category) {
                url.searchParams.set('category', this.category);
            }
            // url.searchParams.set('place', this.$refs.place.getPlzsFromIds(this.place));

            if (this.place) {
                url.searchParams.set('pids', this.place);
            }

            location.href = url.href;
        },
    },
};
